import moment from "moment";
import curry from "./curry";

const since = curry((durationType, start, end) =>
  moment(end).diff(start, durationType)
);

export default since;
